import WarrantyApiService from '@/services/WarrantyApiService/WarrantyApiService'
import type { ManufacturingOrder } from '@/stores/app.store'
import { useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'

type ResponseData = ManufacturingOrder

export const useFetchManufacturingOrder = (orderNumber: Ref<string>) => {
  return useQuery<ResponseData>({
    queryKey: ['fetch-data'],
    queryFn: async () => {
      const response = await WarrantyApiService.getManufacturingOrder(orderNumber.value)

      if (response.isWrong()) {
        throw new Error(response.value.message)
      }

      return {
        id: response.value.id,
        productId: response.value.productId,
        orderNumber: response.value.orderNumber,
        status: response.value.status,
        productUnitCode: response.value.productUnitCode,
        primaryColorName: response.value.primaryColorName,
        secondaryColorName: response.value.secondaryColorName,
        primaryColorHex: response.value.primaryColorHex,
        secondaryColorHex: response.value.secondaryColorHex,
        year: response.value.year,
        total: response.value.total,
        checked: response.value.checked,
        problem: response.value.problem,
        imageUrl: response.value.imageUrl,
        dataLoadedAt: response.value.dataLoadedAt,
        material: response.value.material,
        description: response.value.description,
        size: response.value.size
      }
    },
    retry: false,
    enabled: false
  })
}
